import logo from './logo_sidebar.svg';

export const settings = {
    "title": "BBM Design CRM",
    "apiUrl": "https://api.bbmdesign.geniuscloud.it/api",
    "ckdPath": "https://api.bbmdesign.geniuscloud.it/",
    "tinyKey": "uxd8thxx2a96p0tne20wyfcdx7zvpyprm38j5q5w9qqauy2p",
    //"googleMapKey": "AIzaSyB0JItfx2zvDnKkmxIBt_wru36tOVcx1iM",
    "config": {
        "limit": 50,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "configEntity": {
        "customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "supplier": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "sales_agent": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        }
    },
    "theme": {
        "siderbarIconColor": 'rgba(233,236,239,.5)'
    },
    "logo": logo,
    "data_print": {
        "name": 'BBM Design Srl',
        "address": 'Via Mestre, 18 00182 Roma(RM)',
        "phone": 'Tel: 06 7022691',
        "fax": '',
        "email": '',
        "iva": 'P.IVA: 14791881007',
        "cf": '',
        "website": 'Sito Web: www.cucineeco.it',
    },
    "stampe": {
        "arredatore": false,
        "sconto": true,
        "listino": true,
        "condVendita": false,
        "firmaVenditore": false
    },
    "dati_pagamento": {
        "iban": "IT34X0503403214000000004014",
        "banca": "",
        "bic": "",
        "intestatario": "",
    },
    "dati_fattura": {
        "statoPIVA": "IT",
        "PIVA": "03490440264",
        "PIVAcompleta": "IT03490440264",
        "regimeFiscale": "RF04",
        "numeroREA": "",
        "socioUnico": "",
        "statoLiquidazione": "",
        "ufficio": "",
        "indirizzo": "Corte delle Rose, 8",
        "cap": "31015",
        "comune": "Conegliano",
        "nazione": "IT",
        "provincia": "TV",
        "formatoTrasmissione": "FPR12",
        "codiceDestinatario": "A4707H7",
        "denominazione": "Prelude Advertising",
    },
    "iva_label": 'inclusa',
    "iva_esclusa": false,
    "sconti": true
}